import React from "react";
import { Box } from "rebass/styled-components";

export function MenuDivider(props) {
  return <Box variant="menuDivider" {...props} />;
}
